import { questionTopicConstants } from '../../constants';

const initialQuestionTopicsState = {
  questionTopicList: [] as any[],
  loading: false
};

export function questionTopics(state = initialQuestionTopicsState, action: any) {
  switch (action.type) {
    case questionTopicConstants.GETALL_REQUEST:
      return { ...state, loading: true };
    case questionTopicConstants.GETALL_SUCCESS:
      return { ...state, loading: false, questionTopicList: action.payload };
    case questionTopicConstants.GETALL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    
    case questionTopicConstants.CREATE_REQUEST:
      return { ...state, loading: true };
    case questionTopicConstants.CREATE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        questionTopicList: [...state.questionTopicList, action.payload] 
      };
    case questionTopicConstants.CREATE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    
    case questionTopicConstants.UPDATE_REQUEST:
      return { ...state, loading: true };
    case questionTopicConstants.UPDATE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        questionTopicList: state.questionTopicList.map((topic: any) => 
          topic.id === action.payload.id ? action.payload : topic
        )
      };
    case questionTopicConstants.UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    
    case questionTopicConstants.DELETE_REQUEST:
      return { ...state, loading: true };
    case questionTopicConstants.DELETE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        questionTopicList: state.questionTopicList.filter((topic: any) => topic.id !== action.payload)
      };
    case questionTopicConstants.DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    
    default:
      return state;
  }
}
